import React from 'react';
import { FaCrown } from 'react-icons/fa';
import { activateOnKey } from './LeaderboardParts';
import './Podium.css';

/*
 * Top three as big cards above the table: #2 · #1 · #3 on desktop, #1 first on phones.
 * Each rank has its own render of an ARK boss from the game files (Dragon, Megapithecus,
 * Broodmother), lit in its medal colour.
 */
const ART = {
  1: { src: '/art/podium-1-dragon.jpg', label: 'Champion', boss: 'Dragon' },
  2: { src: '/art/podium-2-megapithecus.jpg', label: '2nd', boss: 'Megapithecus' },
  3: { src: '/art/podium-3-broodmother.jpg', label: '3rd', boss: 'Broodmother' },
};
const TIER = { 1: 'gold', 2: 'silver', 3: 'bronze' };

/**
 * entries: up to three { rank, name, sub, statLabel, statValue, onOpen, openLabel }.
 */
export default function Podium({ entries }) {
  if (!entries || entries.length === 0) return null;
  const byRank = Object.fromEntries(entries.map(e => [e.rank, e]));
  const order = [2, 1, 3].filter(r => byRank[r]);

  return (
    <section className="podium-row" aria-label="Top three">
      {order.map(rank => {
        const e = byRank[rank];
        const art = ART[rank];
        return (
          <div
            key={rank}
            className={`podium-card podium-card--${TIER[rank]}${rank === 1 ? ' podium-card--first' : ''}`}
            role="button"
            tabIndex={0}
            onClick={e.onOpen}
            onKeyDown={activateOnKey(e.onOpen)}
            aria-label={`${art.label}: ${e.name}, ${e.statValue} ${e.statLabel}. ${e.openLabel}`}
          >
            <img className="podium-art" src={art.src} alt="" loading={rank === 1 ? 'eager' : 'lazy'} />
            <div className="podium-shade" aria-hidden="true" />
            <div className="podium-top">
              <span className="podium-medal" aria-hidden="true">
                {rank === 1 && <FaCrown className="podium-crown" aria-hidden="true" />}
                {rank}
              </span>
              <span className="podium-label">{art.label}</span>
            </div>
            <div className="podium-body">
              <span className="podium-name font-display">{e.name}</span>
              {e.sub && <span className="podium-sub">{e.sub}</span>}
              <span className="podium-stat">
                <span className="podium-stat-value font-display">{e.statValue}</span>
                <span className="podium-stat-label">{e.statLabel}</span>
              </span>
            </div>
          </div>
        );
      })}
    </section>
  );
}
